module.exports = function(app) {
    app.directive('slidedownInternalCloseButton', ['$timeout',
        function($timeout) {

            return {
                restrict: 'A',
               // template: require('directives/slidedownInternalCloseButton.html'),
                templateUrl: 'wellness.appTemplate.html/chmhom/directives/slidedownInternalCloseButton',
                scope: {
                    toggleBoolean: "="
                },
                link: function(scope, el, attrs){
                    scope.collapseSlidedown = function(){
                        $timeout(function(){
                            var target = el.closest('.slidedown-wrapper').find('.toggle-slidedown');
                            target[0].focus();
                            target.trigger('click');
                            scope.toggleBoolean = false;
                            scope.$apply();
                        });

                    };
                }
            };
        }
    ]);
};